"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const ICON_BASE = "/image/new-version/ValueAddedSolutions/assembly/图标/图标-2";

const STEPS = [
	{ keyPrefix: "processStep1", icon: `${ICON_BASE}/design-overview.svg` },
	{ keyPrefix: "processStep2", icon: `${ICON_BASE}/part-preparation.svg` },
	{ keyPrefix: "processStep3", icon: `${ICON_BASE}/assembly.svg` },
	{ keyPrefix: "processStep4", icon: `${ICON_BASE}/packaging-delivery.svg` },
] as const;

export default function AssemblyProcess() {
	const t = useTranslations("new-assembly");

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("processTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("processDesc")}</p>
				</header>

				<div className="grid gap-x-12 gap-y-12 md:grid-cols-2 lg:gap-x-24 lg:gap-y-16">
					{STEPS.map((step, index) => (
						<article key={step.keyPrefix} className={`max-w-[620px] ${index % 2 === 1 ? "md:mt-32" : ""}`}>
							<div className="mb-5 flex h-16 w-16 items-center justify-center sm:h-20 sm:w-20">
								<Image
									src={step.icon}
									alt={t(`${step.keyPrefix}ImageAlt`)}
									width={80}
									height={80}
									className="h-full w-full object-contain"
								/>
							</div>
							<div className="mb-2 flex items-baseline gap-3 sm:mb-3">
								<span className="text-sm font-semibold text-themePrimary400">
									{t(`${step.keyPrefix}Number`)}
								</span>
								<h3 className="text-lg font-bold leading-tight text-black sm:text-xl md:text-2xl">
									{t(`${step.keyPrefix}Title`)}
								</h3>
							</div>
							<p className="text-sm leading-relaxed text-black md:text-base">{t(`${step.keyPrefix}Desc`)}</p>
						</article>
					))}
				</div>
			</div>
		</section>
	);
}
